import React from "react";
import PaymentMethods from "./common/PaymentMethods";
import PaymentSettings from "./common/PaymentSettings";

function ManagePaymentMethodsDesktop({
  user,
  SettingsButton,
  SettingsInputContainer,
  addPaymentMethod,
  removePaymentMethod,
  relinkPaymentMethod,
  handlePaymentMethodChanged,
  updateFinicityPaymentMethods,
  handlePaymentSettingsChanged,
  handleSmartPayMethodChanged,
  handleSmartPaySettingsChanged,
  disabledDefaultPaymentMethodIds,
  disabledSmartPayPaymentMethodIds,
  saveChanges,
  inProgress,
  hasChanges,
  errorMessage,
  setErrorMessage,
  resetSuccess,
  setError,
  isMobile,
  roles,
  showSmartPay,
  complete
}) {
  return (
    <div className="mt-4">
      <div className="flex">
        <PaymentMethods
          user={user}
          SettingsButton={SettingsButton}
          addPaymentMethod={addPaymentMethod}
          removePaymentMethod={removePaymentMethod}
          relinkPaymentMethod={relinkPaymentMethod}
          handlePaymentMethodChanged={handlePaymentMethodChanged}
          updateFinicityPaymentMethods={updateFinicityPaymentMethods}
          disabledDefaultPaymentMethodIds={disabledDefaultPaymentMethodIds}
          saveChanges={saveChanges}
          inProgress={inProgress}
          hasChanges={hasChanges}
          setErrorMessage={setErrorMessage}
          resetSuccess={resetSuccess}
          setError={setError}
          isMobile={isMobile}
          complete={complete}
        />
        <PaymentSettings
          user={user}
          SettingsButton={SettingsButton}
          handlePaymentSettingsChanged={handlePaymentSettingsChanged}
          handleSmartPayMethodChanged={handleSmartPayMethodChanged}
          handleSmartPaySettingsChanged={handleSmartPaySettingsChanged}
          disabledSmartPayPaymentMethodIds={disabledSmartPayPaymentMethodIds}
          inProgress={inProgress}
          setErrorMessage={setErrorMessage}
          isMobile={isMobile}
          roles={roles}
          showSmartPay={showSmartPay}
        />
      </div>
      {errorMessage && <div className="mt-4 text-red-500">{errorMessage}</div>}
    </div>
  );
}

export default ManagePaymentMethodsDesktop;
